module.exports = __webpack_public_path__ + "static/telephone-darkgrey-52dc47e5c1f1eaf61bc395e2d77bd03c.png";